news11.vue<template>
<div>
		<sub-header bizCd="10"/>
	 	<div class="sub_visual sub10">
            <div class="container">
                <div class="sub_txt">
                    <div class="tit">보도자료</div>
                    <div class="comment">언론에 소개된 에듀윌의 다양한 소식을 만나보세요.</div>
                </div>
            </div>
        </div>
        <div class="contents aos-all">
            <div class="container">
                <div class="sec">
                    <h3>보도자료</h3>
                    <div class="board">
                        <div class="board_header">
                            <h4>에듀윌 공인중개사 교재, 예스24 베스트셀러 1~27위 석권</h4>
                            <div class="board_meta">
<!--                                <ul>-->
<!--                                    <li>등록일 : 22.05.24</li>-->
<!--                                    <li>조회수 : 142</li>-->
<!--                                </ul>-->
                            </div>
                        </div>
                      <div class="board_body">
                            <div class="board_content">
                              <h2>에듀윌 공인중개사 교재, 예스24 베스트셀러 1~27위 석권… “절대 교재 등극”</h2>
                              <p>&nbsp;</p>
                              <p>- 5월 공인중개사 부문 1위부터 27위까지 모두 에듀윌 교재가 독차지<br>- 10개년 기출 분석 기반 교재와 맞춤형 특강 교재 인기</p>
                              <p>&nbsp;</p>
                              <figure class="image"><img src="//company.eduwill.net/contents/img/20250710172440.jpg"></figure>
                              <p>(2025.06.11) AI교육기업 에듀윌(대표 양형남)의 공인중개사 교재가 온라인서점 예스24의 5월 공인중개사 부문 베스트셀러 1위부터 27위까지
                                석권했다.</p>
                              <p>&nbsp;</p>
                              <p>에듀윌 공인중개사 교재는 매월 베스트셀러 상위권을 독차지하며 '국민 수험서'로 자리매김해왔다. 지난 2월과 3월에는 1위~16위, 4월에는 1위~22위를
                                차지하더니 5월에는 27위까지 모두 에듀윌 교재로 채우며 압도적인 성과를 기록했다.</p>
                              <p>예스24의 월별 베스트셀러는 판매량을 기준으로 산정되어, 에듀윌이 지난 한 달간 공인중개사 교재 시장에서 독보적인 판매 실적을 올렸음을 보여준다.</p>
                              <p>&nbsp;</p>
                              <p>베스트셀러 1위에 오른 '단원별 기출문제집 1차 민법·민사특별법'을 비롯한 기출문제집 시리즈는 공인중개사 시험 10개년 기출 분석을 바탕으로 제작되어 출제
                                경향 파악과 학습 방향 설정에 도움을 준다. 유형별 핵심 기출문제 풀이를 통해 이론을 체계적으로 정리할 수 있어 수험생들 사이에서 호평받고 있다.</p>
                              <p>&nbsp;</p>
                              <p>에듀윌에 따르면 매년 단원별기출문제집 및 기출응용문제집 시리즈가 인기를 끌어왔으며, 올해는 수험생 맞춤형 신간 교재들이 빠른 상승세를 보이며 상위권에
                                진입했다. '오시훈 테마별 비교정리 부동산공법', '김민석 테마별 한쪽정리 부동산공시법', '이영방 합격패스 계산문제 부동산학개론' 등 에듀윌 1타 교수진의
                                특강 교재들이 특히 주목받고 있다.</p>
                              <p>&nbsp;</p>
                              <p>이들 교재는 기존 강의 교안의 품질을 대폭 향상시켜 효과적인 복습과 취약점 보완이 가능하도록 설계됐다. 강의 수강 후 관련 문제풀이를 통해 실력을 점검하고
                                부족한 부분을 빠르게 보완할 수 있다.</p>
                              <p>&nbsp;</p>
                              <p>특히 '이영방 합격패스 계산문제 부동산학개론' 교재는 수험생들이 어려워하는 계산문제를 쉽고 빠르게 해결할 수 있도록 구성했으며, '오시훈 비교정리
                                부동산공법'은 여러 법에 분산된 공법 내용을 혼동하기 쉬운 10가지 핵심 주제로 압축해 비교·정리한 것이 특징이다.</p>
                              <p>&nbsp;</p>
                              <p>에듀윌 관계자는 "수험생들의 학습 효율성을 높이기 위해 지속적으로 교재 품질 개선에 힘쓰고 있다"며 "베스트셀러 1위부터 27위까지 모두 에듀윌 교재가
                                차지한 만큼 더욱 책임감을 갖고 수험생 중심의 콘텐츠 개발에 최선을 다하겠다"고 밝혔다.</p>
                              <p>에듀윌 공인중개사 교재는 에듀윌 도서몰을 비롯해 교보문고, 알라딘, 예스24 등 온오프라인 서점에서 구매할 수 있다.</p>
                              <p>&nbsp;</p>
                            </div>
                        </div>
                        <div class="board_nav">
                            <ul>

                                <!-- 이전 보도 기사가 있을 경우 -->

<!--                                <li class="prev">
                                    <router-link to="/edu/newsRelease/promotionVideo/news19" data-value="315283">
                                        <strong>이전</strong>
                                        <span>에듀윌, 폭스에듀와 MOU 체결… ‘미래 교육 판도 대변혁 시동’</span>
                                    </router-link>
                                </li>-->

                                <!-- //이전 보도 기사가 있을 경우 -->

                              <!-- 다음 보도 기사가 있을 경우 -->
                              <li class="next">
                                <router-link to="/edu/newsRelease/promotionVideo/news25" data-value="315283">
                                  <strong>다음</strong>
                                  <span>에듀윌, AI교육기업으로 대전환 선언…“전국민 AI 성공시대 연다”</span>
                                </router-link>
                              </li>
                              <!-- //다음 보도 기사가 있을 경우 -->

                            </ul>
                        </div>
                        <div class="board_footer">
                            <div class="button-area">
                                <router-link to="/edu/newsRelease/main" class="lg-btn">
                                목록으로
                                </router-link>                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import SubHeader from "@/layouts/SubHeader";

export default {
	name: "MainOnlineEdu",
	components: {SubHeader},
	data() {
		return {
			swiper : ""
		}
	},
	
	computed: {
	},
	
	methods: {
	},
	
	created() {
	},
	beforeMount() {
	},
	mounted() {
		AOS.init({ easing: 'ease-in-out-sine' })
		
		this.swiper = new Swiper("#vi-role.swiper-container", {
	        loop: true,
	        loopFillGroupWithBlank: true,
	        navigation: {
	          nextEl: ".swiper-button-next",
	          prevEl: ".swiper-button-prev"
	        }
	    });
		
		$(".pa_slider_scroll").simplyScroll({
	        customClass:'vert',
			speed: 5,
	        pauseOnHover : true
	    });
	},
	beforeDestroy() {
	},
	destroyed() {
	}
}
</script>
